import React from 'react';

import Header from '../components/Header'
import Footer from '../components/Footer'
import DocPG from '../components/DocPg'
import MainNavigation from '../components/MainNavigation'

export default (props) => (
    <div>
        <Header></Header>
        <MainNavigation></MainNavigation>
        <DocPG></DocPG>
        <Footer></Footer>
    </div>
)
